import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {AI_FEATURES_ENABLED} from '../helpers/featureFlags';
import {useAiAvailable} from '../contexts/AiAvailability';
import {Context} from '../contexts/WordList';

const IconLibrary = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M4 4v15.5" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z" />
  </svg>
);

const IconCards = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <path d="M8 9h8" />
    <path d="M8 13h5" />
  </svg>
);

const IconChat = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
  </svg>
);

const IconAdmin = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 15.5A3.5 3.5 0 1 0 12 8a3.5 3.5 0 0 0 0 7.5Z" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1A2 2 0 1 1 4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9L4.2 7A2 2 0 1 1 7 4.2l.1.1a1.7 1.7 0 0 0 1.9.3 1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1A2 2 0 1 1 19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.5 1h.1a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" />
  </svg>
);

const IconVerb = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 6h16" />
    <path d="M7 12h10" />
    <path d="M9 18h6" />
    <path d="M12 6v12" />
  </svg>
);

const IconProgress = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 3v18h18" />
    <path d="M7 14l4-4 3 3 5-6" />
  </svg>
);

export const MobileBottomNav = ({location}) => {
  const [state] = useContext(Context);
  const isWords = location.pathname === '/';
  const isStudy = location.pathname === '/study';
  const isProgress = location.pathname === '/progress';
  const isPractice = location.pathname === '/practice';
  const isAdmin = location.pathname === '/admin';
  const isVerbs = location.pathname === '/verbs' || location.pathname === '/verb-drill';
  const {aiAvailable, aiChecking} = useAiAvailable();

  return (
    <nav className="mobile-bottom-nav" aria-label="Primary navigation">
      <Link to="/" className={`mobile-bottom-tab${isWords ? ' active' : ''}`} aria-current={isWords ? 'page' : undefined}>
        <span className="tab-icon-wrap"><IconLibrary /></span>
        <span className="mobile-bottom-tab-label">Words</span>
      </Link>

      <Link to="/study" className={`mobile-bottom-tab${isStudy ? ' active' : ''}`} aria-current={isStudy ? 'page' : undefined}>
        <span className="tab-icon-wrap"><IconCards /></span>
        <span className="mobile-bottom-tab-label">Study</span>
      </Link>

      <Link to="/progress" className={`mobile-bottom-tab${isProgress ? ' active' : ''}`} aria-current={isProgress ? 'page' : undefined}>
        <span className="tab-icon-wrap"><IconProgress /></span>
        <span className="mobile-bottom-tab-label">Progress</span>
      </Link>

      {AI_FEATURES_ENABLED && (
        <Link to="/practice" className={`mobile-bottom-tab${isPractice ? ' active' : ''}`} aria-current={isPractice ? 'page' : undefined}>
          <span className="tab-icon-wrap" style={{position: 'relative'}}>
            <IconChat />
            {!aiChecking && !aiAvailable && (
              <span
                style={{position: 'absolute', top: 0, right: 0, width: 8, height: 8, borderRadius: '50%', background: '#ff3b30', border: '1.5px solid var(--surface)'}}
                title="AI service offline"
              />
            )}
          </span>
          <span className="mobile-bottom-tab-label">Practice</span>
        </Link>
      )}

      {state.language === 'hebrew' && (
        <Link to="/verbs" className={`mobile-bottom-tab${isVerbs ? ' active' : ''}`} aria-current={isVerbs ? 'page' : undefined}>
          <span className="tab-icon-wrap"><IconVerb /></span>
          <span className="mobile-bottom-tab-label">Verbs</span>
        </Link>
      )}

      <Link to="/admin" className={`mobile-bottom-tab${isAdmin ? ' active' : ''}`} aria-current={isAdmin ? 'page' : undefined}>
        <span className="tab-icon-wrap"><IconAdmin /></span>
        <span className="mobile-bottom-tab-label">Admin</span>
      </Link>
    </nav>
  );
};
